module.exports = __webpack_public_path__ + "static/media/1017255.caf76d62.png";